import { Button } from '@/components/ui/button';
import type { SilencePhase } from '@/hooks/useSilenceMonitor';

interface RecordingSilenceBannerProps {
  phase: SilencePhase;
  secondsRemaining: number;
  onCancel: () => void;
  onResume: () => void;
  /** Offers a way to switch microphones from the no-input warning (the embed). */
  onChooseMicrophone?: () => void;
}

const formatCountdown = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};

export const RecordingSilenceBanner = ({
  phase,
  secondsRemaining,
  onCancel,
  onResume,
  onChooseMicrophone,
}: RecordingSilenceBannerProps) => {
  if (phase === 'no-input') {
    return (
      <div className="mx-2 mt-2 mb-2 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-amber-800 text-sm">
        <span className="flex-1">
          Ekkert hljóð berst frá hljóðnemanum. Athugaðu hljóðnemann og hljóðstillingar, eða endurhladdu síðuna.
        </span>
        {onChooseMicrophone && (
          <Button
            variant="outline"
            size="sm"
            onClick={onChooseMicrophone}
            className="border-amber-400 text-amber-700 hover:bg-amber-100"
          >
            Velja hljóðnema
          </Button>
        )}
      </div>
    );
  }

  if (phase === 'countdown') {
    return (
      <div className="mx-2 mt-2 mb-2 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-amber-800 text-sm">
        <span className="flex-1">
          Ekkert tal í 5 mínútur. Upptaka stöðvast sjálfkrafa eftir {formatCountdown(secondsRemaining)}.
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={onCancel}
          className="border-amber-400 text-amber-700 hover:bg-amber-100"
        >
          Hætta við
        </Button>
      </div>
    );
  }

  if (phase === 'stopped') {
    return (
      <div className="mx-2 mt-2 mb-2 flex items-center gap-2 rounded-lg border border-red-300 bg-red-50 px-3 py-2 text-red-800 text-sm">
        <span className="flex-1">Upptaka stöðvuð sjálfkrafa vegna þagnar.</span>
        <Button variant="outline" size="sm" onClick={onResume} className="border-red-400 text-red-700 hover:bg-red-100">
          Halda áfram
        </Button>
      </div>
    );
  }

  return null;
};
